import { render } from "./ParkingFleetDetailsStatements.vue?vue&type=template&id=62410130"
import script from "./ParkingFleetDetailsStatements.vue?vue&type=script&lang=js"
export * from "./ParkingFleetDetailsStatements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__